<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add Third Party"></aw-bread-crumb>

  <aw-toast></aw-toast>
  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Third Party'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="form-container">
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      [multiline]="true"
      title="Third-Party Name"
      [maxCharacters]="nameMaxLength"
      [allowedPattern]="namePattern"
      [patternMessage]="namePatternMessage"
      (textEntry)="onNameSelected($event)"
    ></app-aw-text-form>

    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onStatusSelected($event)"
    ></app-aw-dropdown-form>
  </div>

  <div class="employee-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'Third-Party Employee Authentication (Required)'"
      [altColor]="true"
    >
    </aw-divider>

    <div class="auth-type-label">
      <label class="aw-st-1-medium aw-text-primary">Authentication Type: OpenID Connect</label>
    </div>

    <app-aw-auth-form
      [authType]="employeeAuthTypeValue"
      [values]="employeeAuthFieldsValues"
      [authenticationVersion]="'employee'"
      (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
    ></app-aw-auth-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"></aw-action-bar>
</div>
